<template>
  <div id="app" class="app">
    <div class="app__content">
      <main class="main" ref="main" :class="`${fullClass}`">
        <transition :name="routerTransition" mode="out-in">
          <router-view />
        </transition>
      </main>
    </div>

    <foot v-if="!isCards" :class="`${fullClass} ${transparentClass}`"></foot>
  </div>
</template>

<script>
// Components
import foot from '@/layout/foot.vue';

export default {
  name: 'app',
  data() {
    return {
      routerTransition: 'fade',
    };
  },
  components: {
    foot,
  },
  computed: {
    isCards() {
      return this.$route.name === 'cards';
    },
    fullClass() {
      let fixedOn = ['buildings', '3d', 'login'];
      return fixedOn.includes(this.$route.name) ? 'full' : '';
    },
    transparentClass() {
      let transparentOn = ['login'];
      return transparentOn.includes(this.$route.name) ? 'transparent' : '';
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700&display=swap&subset=latin-ext');
@import '@/styles/transitions.scss';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline-color: $primaryColor;
}

body {
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}

.app {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.app__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.main {
  flex: 1;
  background: #fff;
  position: relative;
  //max-height: $fullHeight;
  height: 100%;
  // padding-bottom: $breadcrumbsHeight / 1.5;
  // &.full {
  //   max-height: $noBreadcrumbsHeight;
  //   padding-bottom: 0;
  // }
}
@import '@/styles/customStyles.scss';
</style>
